import React, { useContext, useEffect } from "react";

import ReactGA from "react-ga4";

import { WorkshopContext } from "../contexts/workshop.context";
import {
  Header,
  Hero,
  TeamCommunicationPreferences,
  TeamRoles,
  TeamStrengths,
  Footer,
  TeamSkills,
  SuccessPillars,
  TeamMaps,
  FollowUpGoals
} from "../components/insights";
import { ScrollToTopButton } from "../components/common";

const Insights = () => {
  const {
    socket,
    workshopDetails: {
      id,
      teamName = "[Team Name]",
      roomData,
      pdf,
      platform,
      workshopDateString,
      demoWorkshop,
      mftPublic,
      mftPublicTeam
    } = {}
  } = useContext(WorkshopContext);

  useEffect(() => {
    if (!demoWorkshop) return;

    ReactGA.initialize("G-SED12RVZLJ");
  }, [demoWorkshop]);

  const oldWorkshopsDateThreshold = new Date("2025-06-11T00:00:00.000Z");
  const isOldWorkshop = new Date(workshopDateString) < oldWorkshopsDateThreshold;
  const hideSuccessPillarsSpecificWorkshops = [
    "675aa29f82fcb8dbb783e18d",
    "679cb402228a44092f4e78cb",
    "679b4d34228a44092f4e78ca"
  ];
  const isSuccessPillarsHidden = hideSuccessPillarsSpecificWorkshops.includes(id);

  return (
    <section
      id="insights"
      className={`font-inter mx-auto ${pdf ? "bg-white-100" : ""}`}
      style={{
        maxWidth: !pdf && "1100px"
      }}>
      {!pdf && (
        <Header
          id={id}
          socket={socket}
          platform={platform}
          demoWorkshop={demoWorkshop}
          mftPublicTeam={mftPublicTeam}
        />
      )}
      {platform === "mft" ? (
        <>
          {!pdf && (
            <Hero
              teamName={teamName}
              workshopDate={workshopDateString}
              id={id}
              platform={platform}
              socket={socket}
              mftPublic={mftPublic}
              mftPublicTeam={mftPublicTeam}
            />
          )}
          <TeamMaps
            mapNames={roomData?.task4}
            platform={platform}
            mftPublic={mftPublic}
            mftPublicTeam={mftPublicTeam}
            isPdf={pdf}
            showStats={mftPublic || mftPublicTeam}
          />
          <TeamStrengths
            strengths={roomData?.strengths}
            users={roomData?.users}
            strengthsSubmissions={roomData?.strengthsSubmissions}
            isPdf={pdf}
            platform={platform}
            mftPublic={mftPublic}
            mftPublicTeam={mftPublicTeam}
            showStats={mftPublic || mftPublicTeam}
          />
          <TeamRoles
            roles={roomData?.roles}
            users={roomData?.users}
            rolesSubmissions={roomData?.rolesSubmissions}
            isPdf={pdf}
            platform={platform}
            mftPublic={mftPublic}
            mftPublicTeam={mftPublicTeam}
            showStats={mftPublic || mftPublicTeam}
          />
          <TeamCommunicationPreferences
            starSelections={roomData?.task8}
            attitudesSelections={roomData?.task9}
            users={roomData?.users}
            isPdf={pdf}
            platform={platform}
            mftPublic={mftPublic}
            mftPublicTeam={mftPublicTeam}
            showStats={mftPublic || mftPublicTeam}
          />
          {!pdf && mftPublicTeam && <FollowUpGoals isPdf={pdf} platform={platform} />}
          {/* {mftPublicTeam && !pdf && <TeamAttitudesDisplay platform={platform} isPdf={pdf} />} */}
          {!pdf && (
            <Footer platform={platform} mftPublic={mftPublic} mftPublicTeam={mftPublicTeam} />
          )}
        </>
      ) : (
        <>
          {!pdf && (
            <Hero
              teamName={teamName}
              workshopDate={workshopDateString}
              id={id}
              socket={socket}
              demoWorkshop={demoWorkshop}
            />
          )}
          <TeamMaps mapNames={roomData?.task4} platform={platform} isPdf={pdf} />
          <TeamStrengths
            strengths={roomData?.strengths}
            users={roomData?.users}
            strengthsSubmissions={roomData?.strengthsSubmissions}
            isPdf={pdf}
            platform={platform}
          />
          <TeamRoles
            roles={roomData?.roles}
            users={roomData?.users}
            rolesSubmissions={roomData?.rolesSubmissions}
            isPdf={pdf}
            platform={platform}
          />
          <TeamCommunicationPreferences
            starSelections={roomData?.task8}
            attitudesSelections={roomData?.task9}
            users={roomData?.users}
            isPdf={pdf}
            platform={platform}
          />
          <TeamSkills
            users={roomData?.users}
            skillsSubmissions={roomData?.task10?.skillsSubmissions}
            isPdf={pdf}
            platform={platform}
          />
          {isOldWorkshop && !demoWorkshop && !isSuccessPillarsHidden && (
            <SuccessPillars
              users={roomData?.users}
              successPillarsSubmissions={roomData?.task10?.successPillarsSubmissions}
              isPdf={pdf}
            />
          )}
          {!pdf && <FollowUpGoals isPdf={pdf} />}
          {!pdf && <Footer platform={platform} mftPublic={mftPublic} />}
        </>
      )}

      <ScrollToTopButton />
    </section>
  );
};

export default Insights;
